import { Grid } from "@mui/material";
import dynamic from "next/dynamic";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { CMSImageType } from "@Types/Contentful";
import { ContentfulImageProps } from "../contentful-image/ContentfulImage";
import classes from "./SectionTextImage.module.scss";

export interface SectionTextImageProps {
  title: string;
  caption?: string;
  description?: string;
  imageToRight: boolean;
  image?: CMSImageType;
}

const DynamicImage = dynamic<ContentfulImageProps>(
  () =>
    import("../contentful-image/ContentfulImage").then(
      (mod) => mod.ContentfulImage
    ),
  { ssr: false }
);

export default function SectionTextImage(props: SectionTextImageProps) {
  const { title, caption, description, imageToRight, image } = props;

  const imageToRightClass = imageToRight
    ? `section__content ${classes["image-swap"]} ${classes["force-swap"]}`
    : `section__content ${classes["image-swap"]}`;

  return (
    <section className="section">
      <Grid container alignContent="center" className={imageToRightClass}>
        <Grid item xs={12} md={6} className={classes["image-container"]}>
          <DynamicImage
            src={image?.url?.split("?")?.[0] || ""}
            alt={image?.title || ""}
            layout="fill"
            objectFit="cover"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={classes["text-content"]}>
            <h2>{title}</h2>
            {caption ? <h3>{caption}</h3> : <></>}
            {description ? (
              <div className={classes["text-body"]}>
                <CmsTextEditorContent content={description} />
              </div>
            ) : (
              <></>
            )}
          </div>
        </Grid>
      </Grid>
    </section>
  );
}
